import React from "react";
import { Checkbox } from "@material-ui/core";

import { withStyles } from '@material-ui/styles';

const MaterialCheckbox = withStyles({
  colorSecondary: {
    color: "#909090",
    "&:hover": {
      backgroundColor: 'rgb(164 164 164 / 10%)'
    }
  },
  checked: {
    color: "#277661 !important",
    "&$checked:hover": {
      backgroundColor: 'rgba(41, 197, 156, 0.1)'
    }
  }

})(Checkbox);

export default MaterialCheckbox;